import { useState } from "react";
import { Link } from "react-router-dom";
import { FiUser } from "react-icons/fi";
import UserDataFetcher from "../../../libs/getUserbyUserId";
import useBusinessMerchant from "../../../Routes/Marketplace/Merchant/lib/fetchBusinessMerchant";
import MerchantBusinessForm from "../components/MerchantBusinessForm";
import ChangePasswordForm from "../../../Routes/Marketplace/Merchant/MerchantAccount/MerchantSecurity";
import PageHeader from "../../components/PageHeader";
import TabPanel from "../../components/TabPanel";

const TABS = [
  { id: "profile", label: "Profile" },
  { id: "business", label: "Business" },
  { id: "security", label: "Security" },
];

const MerchantAccountPage = () => {
  const [activeTab, setActiveTab] = useState("profile");
  const { adminData } = UserDataFetcher();
  const { data: businessData, isLoading: businessLoading } = useBusinessMerchant();
  const user = adminData?.user;
  const merchant = businessData?.merchant;

  return (
    <>
      <PageHeader
        title="Account"
        subtitle={user?.isInfoVerify ? "Verified seller" : "Complete verification to start selling"}
        icon={FiUser}
      />
      <TabPanel tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "profile" && user && (
        <div className="dashboard-card">
          <h2 className="dashboard-card__title">Profile</h2>
          <div className="dashboard-detail-grid">
            <p><strong>Name:</strong> {user.first_name} {user.last_name}</p>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>Phone:</strong> {user.phone_number || "—"}</p>
            <p>
              <strong>Status:</strong>{" "}
              <span className={`dashboard-badge ${user.isInfoVerify ? "dashboard-badge--success" : "dashboard-badge--warning"}`}>
                {user.isInfoVerify ? "Verified" : "Pending verification"}
              </span>
            </p>
          </div>
          <p className="dashboard-form-hint" style={{ marginTop: 16 }}>
            Payouts and bank verification are managed on the{" "}
            <Link to="/merchant/payments">Payments</Link> page.
          </p>
        </div>
      )}

      {activeTab === "business" && (
        <>
          {merchant && (
            <div className="dashboard-card dashboard-business-summary">
              <h2 className="dashboard-card__title">Current business profile</h2>
              <div className="dashboard-detail-grid">
                <p><strong>Business name:</strong> {merchant.businessName || "—"}</p>
                <p><strong>Category:</strong> {merchant.businessCategory || "—"}</p>
                <p><strong>Address:</strong> {merchant.businessAddress || "—"}</p>
                <p><strong>City:</strong> {merchant.city || "—"}</p>
                <p><strong>State:</strong> {merchant.state || "—"}</p>
                <p><strong>Contact:</strong> {merchant.contactPerson || "—"} · {merchant.contactEmail || "—"}</p>
              </div>
            </div>
          )}

          <div className="dashboard-card">
            <h2 className="dashboard-card__title">
              {merchant ? "Update business information" : "Set up your business"}
            </h2>
            {!user?.isInfoVerify && (
              <p className="dashboard-form-hint">
                Complete this form so our team can verify your store. All fields are saved to your business profile.
              </p>
            )}
            {!businessLoading && (
              <MerchantBusinessForm initialData={merchant} userProfile={user} />
            )}
          </div>
        </>
      )}

      {activeTab === "security" && (
        <div className="dashboard-card dashboard-security-card">
          <h2 className="dashboard-card__title">Security</h2>
          <p className="dashboard-form-hint">Update your sign-in password.</p>
          <ChangePasswordForm embedded />
        </div>
      )}
    </>
  );
};

export default MerchantAccountPage;
